import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { LangContext } from '../../App.jsx';
import tinycontentAPI from '../../../_api/tinycontent';
import SpoilerInfo from '../common/SpoilerInfo.jsx';
import createMarkup from '../../../_utils/murkup';


const TinyContentInfoBlock = ({ name, without_spoiler }) => {
  const [info, setInfo] = useState('');
  const lang = useContext(LangContext);
  useEffect(() => {
    tinycontentAPI.get(`${name}:${lang}`).then(response => { if (response) setInfo(response.content) });
  }, []);

  if (without_spoiler) return <div dangerouslySetInnerHTML={ createMarkup(info) }></div>;

  return <SpoilerInfo >
      <div dangerouslySetInnerHTML={ createMarkup(info) }></div>
  </SpoilerInfo>;
};

TinyContentInfoBlock.PropTypes = {
  name: PropTypes.string.isRequired,
  without_spoiler: PropTypes.bool
}

export default TinyContentInfoBlock;